import Admin from "../Admin";
import React from "react";
import CardAdminTeamList from "../../../Component/Card/Admin/Team/CardAdminTeamList";
import PageHeader from "../../../Component/PageHeader";
import MUIContainer from "@mui/material/Container";
import MUIButton from "@mui/material/Button";
import MUIAddIcon from "@mui/icons-material/Add";

export default class AdminTeamList extends Admin {
    /**
     * Render the content.
     */
    renderContent() {
        return (
            <CardAdminTeamList />
        );
    }

    /**
     * Render the header.
     */
    renderHeader() {
        const handleClickCreate = () => {
            this.props.history.push({
                pathname: "/admin/team"
            });
        };

        const buttons = [
            (<MUIButton
                component="label"
                variant="contained"
                startIcon={<MUIAddIcon />}
                onClick={handleClickCreate}>Create New</MUIButton>),
        ];

        return (
            <PageHeader title="Teams" buttons={buttons} />
        );
    }
}
